import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import HomeUI from './Home';
import './Home.css';
import { useCookies } from '../../hooks/useCookies';
import { useProfile } from "../../components/userflow/components/context/ProfileContext";
import { handleUserNavigation, checkProfileCompleteness } from "../../utils/handleUserRedirect"
import Loader from '../../components/Utility/Loader';


export const Home = () => {
  const navigate = useNavigate();
  // const [mobile, setMobile] = useState(false); // Mobile state handled internally by LandingPageNew
  const { getCookie } = useCookies();
  const [loading, setLoading] = useState(false);
  const hasChecked = React.useRef(false); // Ref to prevent re-runs

  const token = getCookie('token')
  const userId = getCookie('userId')
  const { fetchProfile } = useProfile();

  const handleRouting = useCallback(async () => {
    if (hasChecked.current) return;
    hasChecked.current = true;

    const success = await fetchProfile();
    const result = success.data;

    if (!success.ok) return;
    if (result) {
      // Check if user needs to finish onboarding
      const completeness = checkProfileCompleteness(result);
      
      if (!completeness.complete) {
        setLoading(false);
        const confirmResume = window.confirm("Do you want to continue the onboarding process?");
        
        if (confirmResume) {
          setLoading(true);
          if (!result?.Email || result?.Email === "") {
            navigate("/emailverify");
          } else {
            await handleUserNavigation(result, navigate, setLoading, "");
          }
        } else {
          // Clear cookies and stay on landing page
          document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          document.cookie = "userId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          document.cookie = "phoneNumber=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          hasChecked.current = false; // Reset if they stay, though they won't have cookies anymore
          setLoading(false);
        }
      } else {
        // Profile is complete, proceed to home
        await handleUserNavigation(result, navigate, setLoading, "");
      }
    } else {
      setLoading(false);
    }
  }, [fetchProfile, navigate, setLoading]);


  useEffect(() => {
    // Redirect to another URL
    if (token && userId && !hasChecked.current) {
      handleRouting()
    }
    else {
      // navigate("/"); // Don't redirect to / if we are already on the landing page (implied)
      // This logic seems to prevent infinite loops if LP is the route for "/"
    }
  }, [token, userId, handleRouting, navigate]);

  // Mobile check removed as LandingPageNew handles responsiveness
  
  if (loading) {
    return <Loader />;
  }
  return (
    <div className="home-mainbox">
      <HomeUI />
    </div>
  );
}

